/* eslint-disable camelcase */
import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditAnswerDetails } from "shared/audits"

const FormSubmissionEditedAuditItemDetails = ({ audit }) => {
  const { auditedChanges } = audit
  const { discarded_at } = auditedChanges

  return (
    <div>
      Edited submission.
      {
        !discarded_at && (
          Object.keys(auditedChanges).map((prompt) => (
            <AuditAnswerDetails key={prompt} prompt={prompt} audit={audit} />
          ))
        )
      }
    </div>
  )
}

FormSubmissionEditedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default FormSubmissionEditedAuditItemDetails
